import React from 'react'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { h4, graphTitle, richText } from '@/styles/typography'
import { container, spacing, screen, grid } from '@/styles/mixins'

import { Link } from 'gatsby'

const normal = css`
  color: #ccc;
  background-color: black;
`

const inverted = css`
  color: white;
  background-color: black;
`

const Container = styled.div`
  /* display: grid; */
  /* grid-template-columns: repeat(2, 1fr); */
  z-index: 3;
  position: relative;
  text-align: center;
  will-change: color, background-color;
  transition: all 0.2s;
  ${container};
  ${inverted};
  justify-items: center;
  position: relative;
  grid-column: 3 / -3;
  ${spacing('paddingTop', 'xl')};
  ${spacing('paddingBottom', 'xl')};

  > * {
    transition: all 0.2s;
  }

  &:hover {
    ${props => (props.odd ? normal : normal)}
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.4rem;
    padding-left: 1rem;
    padding-right: 1rem;
    /* > div {
      &:first-of-type {
        order: 2;
      }
    } */
  }
`

const Content = styled.div`
  text-align: center;

  @media ${screen('md')} {
    grid-column: 4 / -4;
  }

  @media ${screen('ml')} {
    grid-column: 10 / -10;
    ${grid({ cols: 32 })}
  }

  @media ${screen('mx')} {
    grid-column: 14 / -14;
    ${grid({ cols: 22 })}
  }
  h2 {
    ${h4};
    ${richText};
    margin-bottom: 2rem;
  }
  .excerpt {
    p {
      ${graphTitle};
    }
  }
  h2,
  .excerpt,
  .more {
    grid-column: 1 / -1;
  }
`

const Extra = styled.div`
  grid-column: 1 / -1;
  padding: 1rem;
`

const LinkOrExternal = ({ slug, externalurl, children }) => {
  if (externalurl) {
    return (
      <a
        href={`${externalurl}?utm_source=especialmigrantes1&utm_medium=interactivo`}
        target="_blank"
        rel="noopener noreferrer">
        {children}
      </a>
    )
  } else {
    return <Link to={`/${slug}/`}>{children}</Link>
  }
}

const ArticleCard = ({
  title,
  type = 'article',
  excerpt,
  slug,
  featuredImage,
  odd,
  metafields = null,
  extraAppend,
  extraPrepend,
}) => {
  const image = featuredImage?.node?.localFile

  return (
    <LinkOrExternal slug={slug} externalurl={metafields?.externalurl}>
      <Container odd={odd}>
        {extraAppend && <Extra className="extra-append">{extraAppend}</Extra>}

        <Content>
          <h2>{title}</h2>
          <div
            className="excerpt"
            dangerouslySetInnerHTML={{ __html: excerpt }}></div>
          <div className="more">
            <span className="inline-block px-4 py-2 border-2 mt-4">
              {metafields?.externalurl ? (
                <span>Leer en latercera.com </span>
              ) : (
                `ver más `
              )}
            </span>
          </div>
        </Content>
        {image && (
          <div>
            <figure>
              <GatsbyImage image={getImage(image)} alt="" />
            </figure>
          </div>
        )}
        {extraPrepend && (
          <Extra className="extra-prepend">{extraPrepend}</Extra>
        )}
      </Container>
    </LinkOrExternal>
  )
}

export default ArticleCard
